/* Split from ResultTrend.tsx for the same reason useAppContext.ts is split
   from AppShell.tsx: a module that exports a component and plain functions
   together breaks fast refresh. The deviation note lives in ResultTrend.tsx
   and covers this file too — both halves of the arithmetic are here. */

export type TrendDirection = "higher" | "lower" | "unchanged";

export function trendDirection(current: number, previous: number): TrendDirection {
  if (current > previous) return "higher";
  if (current < previous) return "lower";
  return "unchanged";
}

/** Signed change from the previous measurement to this one. Rendered to at
    most two fraction digits by the component — the analytes carry varying
    precision (µg/L whole numbers, CRP to two places), and subtracting them in
    binary floating point yields tails like 0.30000000000000004 that are an
    artefact of the arithmetic rather than anything either lab measured. */
export function trendDelta(current: number, previous: number): number {
  return current - previous;
}
